<div class="container-fluid">
  <h4>{{'Calendar.header' | translate}}</h4>
  <div>
    @if (service.currentUser.isReadOnly === false) {
      <button mat-raised-button (click)="OnCreateHoliday()">
        <mat-icon>add</mat-icon> Create New Holiday
      </button>
    }
  </div>

  <div class="mat-elevation-z8 mt-3">

    <div class="search-div">
      <mat-form-field class="search-form-field" style="margin: 0px; padding: 0px;">
        <input matInput [(ngModel)]="searchKey" placeholder="{{'Calendar.plchldrSearchHoliday' | translate}}" autocomplete="off"
          (keyup)="ApplyFilter()">
          @if (searchKey) {
            <button mat-button matSuffix mat-icon-button aria-label="Clear"
              (click)="OnSearchClear()">
              <mat-icon>close</mat-icon>
            </button>
          }
        </mat-form-field>
      </div>
      <div class="scrollableTable">
        <table mat-table [dataSource]="dataSource" matSort matSortActive="actDate" matSortDirection="desc" style="width: 100%;">

          <ng-container matColumnDef="actualDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 15%;"> {{'Calendar.thActualDate' | translate}}</th>
            <td mat-cell *matCellDef="let element">{{element.actualDate | date:"d MMM yyyy"}}</td>
          </ng-container>

          <ng-container matColumnDef="statutoryDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 15%;"> {{'Calendar.thStatutoryDate' | translate}}</th>
            <td mat-cell *matCellDef="let element">{{element.statutoryDate | date:"d MMM yyyy"}}</td>
          </ng-container>

          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: auto;"> {{'Calendar.thPublicHoliday' | translate}}</th>
            <td mat-cell *matCellDef="let element">{{element.description}}</td>
          </ng-container>

          <ng-container matColumnDef="exceptions">
            <th mat-header-cell *matHeaderCellDef style="width: 10%; text-align: right;"> {{'Calendar.thExceptions' | translate}}</th>
            <td mat-cell *matCellDef="let element"  style="text-align: right;">{{element.exceptions.length}}</td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef style="width: 10%; text-align: center;"> {{'thActions' | translate}} </th>
            <td mat-cell *matCellDef="let element" style="text-align: center;">
              @if (service.currentUser.isReadOnly === false) {
                <button mat-icon-button color="primary" (click)="OnEditHoliday(element)">
                  <mat-icon>edit</mat-icon>
                </button>
              }
              &nbsp;
              @if (service.currentUser.isReadOnly === false) {
                <button mat-icon-button color="warn" (click)="OnDeleteHoliday(element)">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="loading">
            <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">{{'tblLoading' | translate}}... </th>
          </ng-container>

          <ng-container matColumnDef="noData">
            <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">{{'Calendar.tblNoData' | translate}}... </th>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
          <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide':dataSource!=null}"></tr>
          <tr mat-footer-row *matFooterRowDef="['noData']"
          [ngClass]="{'hide':(dataSource!=null && holidaysLength != 0) || isLoading === true}"></tr>

        </table>
      </div>
      <!-- <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 50]"  [length]="holidaysLength"></mat-paginator> -->
    </div>

    @if (service.currentUser.isReadOnly === false) {
      <div class="mt-3">
        <button mat-raised-button style="float: right;" color="primary" type="button" (click)="OnSaveHoliday()">{{'btnSave' | translate}}</button>
      </div>
    }
  </div>